import React from 'react'
import { useHistory } from 'react-router-dom'

function Header({ itemCount }) {
    const history = useHistory();
    const close = () => {
        history.push("/");
    }
    return (
        <header className="fixed header-blue">
            <div className="container">
                <div className="header-top">
                    <div className="header-top-left">
                        <span className="back"><img className="img-dark" src="/images/arrow-back.png" alt="" />
                            <img className="img-white" src="/images/arrow-back-white.png" alt="" onClick={close} />
                        </span>
                    </div>
                    <div className="header-top-mid">
                        <span className="font-semibold">Cart</span>
                    </div>
                    <div className="header-top-right"></div>
                </div>
            </div>
        </header>

    )
}

export default Header
